/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
export default function transformProps(chartProps) {
  var {
    width,
    height,
    formData,
    queriesData
  } = chartProps;
  var {
    linearColorScheme,
    numberFormat,
    selectCountry,
    colorScheme,
    sliceId,
    legendNoCells,
    numberFormatLegend,
    legendPosition,
    legendDistribution,
    legendSettableZero,
    legendZeroSymmetricity
  } = formData;
  return {
    width,
    height,
    data: queriesData[0].data,
    country: selectCountry ? String(selectCountry).toLowerCase() : null,
    linearColorScheme,
    numberFormat,
    colorScheme,
    sliceId,
    legendNoCells: Math.max(2, Math.min(20, legendNoCells || 10)),
    numberFormatLegend: numberFormatLegend || 'AS_MAP',
    legendPosition: typeof legendPosition === 'string' && ['left', 'right', 'top', 'bottom'].indexOf(legendPosition.toLowerCase()) !== -1 ? legendPosition.toLowerCase() : 'left',
    legendDistribution: typeof legendDistribution === 'string' && ['linear', 'mid80'].indexOf(legendDistribution.toLowerCase()) !== -1 ? legendDistribution.toLowerCase() : 'linear',
    legendSettableZero: typeof legendSettableZero === 'string' && (['average', 'median'].indexOf(legendSettableZero.toLowerCase()) > -1 || !Number.isNaN(parseFloat(legendSettableZero.replace(',', '.')))) ? !Number.isNaN(parseFloat(legendSettableZero.replace(',', '.'))) ? parseFloat(legendSettableZero.replace(',', '.')) : legendSettableZero.toLowerCase() : 'average',
    legendZeroSymmetricity: typeof legendZeroSymmetricity === 'string' && ['symmetric', 'asymmetric'].indexOf(legendZeroSymmetricity.toLowerCase()) !== -1 ? legendZeroSymmetricity.toLowerCase() : 'symmetric'
  };
}